<script>
  import {Flex, FlexItem, Button, TextField} from "@gl/design-system"
  import { _ } from "svelte-i18n"
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()

  export let searchText = ""
  export let placeholder = ""

  function handleSearch() {
    dispatch("search")
  }

  function resetFilter() {
    searchText = ""
    handleSearch()
  }
</script>

<Flex class="flex-wrap-wrap align-items-center mt-5">
  <FlexItem class="mt-2" style="width:300px">
    <TextField placeholder={placeholder} bind:value={searchText} variant="Search" />
  </FlexItem>

  <FlexItem>
    <Button class="mt-2 ml-2 mr-2" on:click={handleSearch}>{$_("common.search")}</Button>
  </FlexItem>

  <FlexItem>
    <Button outlined class="mt-2" on:click={resetFilter}>{$_("common.reset")}</Button>
  </FlexItem>
</Flex>